import React, { useEffect, useState } from "react";
import { GetAppText } from "../../../../../utils";
import { useSelector } from "react-redux";
import { getRequest } from "../../../../../apis/methods";
import { apiRoutes } from "../../../../../apis/routes";
import { Loader } from "../../../../components/Loader";

export const AboutSunniEndowments = () => {
  const language = useSelector((state) => state.language.value);
const[loading,setLoading]=useState(false)
const[data,setData]=useState("")
useEffect(()=>{
  fetchData()
},[])
  // const data = [
  //   {
  //     id: 1,
  //     heading: "",
  //     para: "مرحبًا بك في صفحة شروط الاستخدام والأحكام لتطبيق افعلوا الخير. يرجى قراءة هذه الشروط بعناية قبل استخدام التطبيق. باستخدام تطبيق افعلوا الخير، فإنك توافق على الامتثال لشروط وأحكام هذا الاتفاق، وتعتبر هذه الموافقة ملزمة قانونًا.",
  //   },
  //   {
  //     id: 2,
  //     heading: "رؤية ورسالة الخير",
  //     para: "نحن ففعلوا الخير نؤمن بأن الخير هو أساس بناء المجتمعات القوية والمتماسكة. نسعى جاهدين إلى ترسيخ قيم العطاء والتكافل في المجتمع من خلال تعزيز روح المسؤولية الاجتماعية. رؤيتنا تتمثل في خلق مجتمع يتشارك فيه الجميع في تحقيق الخير والازدهار. ونسعى إلى تمكين الأفراد والمؤسسات من تقديم المساعدة والدعم لمن هم في حاجة إليها، مع التركيز على القضايا الإنسانية الأساسية كالتعليم والصحة والبنية التحتية.",
  //   },
  //   {
  //     id: 3,
  //     heading: "دورنا في تعزيز التغيير",
  //     para: "نحن ندرك أن التغيير الحقيقي يبدأ من الأفعال البسيطة، ولهذا نعمل على تمكين الناس من اتخاذ خطوات ملموسة نحو تحسين حياة الآخرين. من خلال مشروعاتنا المختلفة، نسعى إلى إحداث تأثير إيجابي في حياة المستفيدين، سواء كان ذلك من خلال بناء المدارس، أو تقديم الرعاية الصحية، أو توفير المياه النظيفة. نؤمن بأن كل مشروع نقوم به يحمل في طياته قوة تغيير هائلة، وأن كل تبرع يمكن أن يحدث فرقًا كبيرًا.",
  //   },
  //   {
  //     id: 4,
  //     heading: "شراكاتنا ومساهماتكم",
  //     para: "ل بتعاون وثيق مع مختلف الشركاء المحليين والدوليين لضمان وصول المساعدات إلى من هم في أمس الحاجة إليها. ونحن نعتبر أن كل مسا البرامج الاستثمارية لدينا تتجاوز مجرد تقديم الخدمات، فهي تهدف إلى خلق بيئة تتيح للناس الفرصة للنمو والتطور والازدهار. كما أننا ملتزمون بالشفافية التامة في جميع أنشطتنا، ونعمل على توفير تقارير دورية تظهر أثر تبرعاتكم والمشاريع التي تم إنجازها بفضل دعمكم المستمر.",
  //   },
  //   {
  //     id: 5,
  //     heading: "لتزامنا بالجودة والشفافية",
  //     para: "في افعلوا الخير، نلتزم بأعلى معايير الجودة والشفافية في تنفيذ مشاريعنا. نحن ندرك أهمية الثقة التي يضعها المتبرعون فينا، لذا نحرص على تقديم تقارير تفصيلية ودقيقة حول جميع أنشطتنا ومشاريعنا. نسعى دائمًا إلى تحسين آليات العمل وتبني أحدث الابتكارات لضمان تحقيق أفضل النتائج. وبالإضافة إلى ذلك، نعمل على بناء شراكات استراتيجية مع منظمات وجمعيات موثوقة لضمان توجيه المساعدات إلى الأماكن الأكثر احتياجًا.",
  //   },
  // ];
  const fetchData = async () => {
    setLoading(true)
    try {
      const response = await getRequest(`${apiRoutes.get_about}`
       
        ); // Replace with your endpoint
if(response.status==="success")
   { 
    setLoading(false)
    setData(response?.data)

  }
  else{
    setLoading(false)
  }
    } catch (error) {
      setLoading(false)
      console.error('Error fetching data:', error);
    }
  };
  return (
    <div className="w-full sm:space-y-6 space-y-4 h-full">
      <h1
        className={`text-primary text-F24 font-bold ${
          language === "_ar" ? "text-right" : "text-left"
        }`}
      >
        {GetAppText("about_sunni_endowments")}
      </h1>
      <div >
      {loading?  <div className="flex h-[550px] w-full justify-center items-center">
 <Loader/>
 </div>
 : data?.value_ar || data?.value ?  <div className={`${language === "_ar" ?"text-right":"text-left"} bg-white p-6 flex-row-reverse rounded-xl`} dangerouslySetInnerHTML={{ __html: language === "_ar" ? data?.value_ar:data?.value }}>

 </div>
        
        :
        (!loading && <div className="flex w-full bg-white rounded-xl h-[450px] justify-center text-F20 font-semibold items-center">
                      {GetAppText("no_data")}
                      </div>)
        
        }
   
      </div>
    </div>
  );
};
